import air_arrival from './air-arrival.js';
import air_start from './air-start.js';
import airplane from './airplane.js';
import alert from './alert.js';
import apple from './apple.js';
import arrow_l from './arrow-l.js';
import arrow_r from './arrow-r.js';
import baggage from './baggage.js';
import bed from './bed.js';
import bus from './bus.js';
import calendar_edit from './calendar-edit.js';
import calendar from './calendar.js';
import call_center from './call-center.js';
import camera from './camera.js';
import cart from './cart.js';
import chat from './chat.js';
import check from './check.js';
import city from './city.js';
import clock from './clock.js';
import curly_quotes from './curly-quotes.js';
import hourglass from './hourglass.js';
import cutlery from './cutlery.js';
import district from './district.js';
import doublebed from './double-bed.js';
import drink from './drink.js';
import email from './email.js';
import engine from './engine.js';
import euro from './euro.js';
import eye_close from './eye-close.js';
import eye_open from './eye-open.js';
import faq from './faq.js';
import filter from './filter.js';
import hands from './hands.js';
import happy_pin from './happy-pin.js';
import have_voucher from './have-voucher.js';
import heart from './heart.js';
import hotel from './hotel.js';
import info from './info.js';
import lamp_light from './lamp-light.js';
import lamp from './lamp.js';
import landmark from './landmark.js';
import lock from './lock.js';
import logout from './logout.js';
import menu from './menu.js';
import moon from './moon.js';
import phone from './phone.js';
import pin from './pin.js';
import plus from './plus.js';
import plus_circle from './plus-circle.js';
import plus_v2 from './plus-v2.js';
import quote from './quote.js';
import round_trip from './round-trip.js';
import shield from './shield.js';
import star from './star.js';
import svg_error from './svg-error.js';
import tags from './tags.js';
import technology from './technology.js';
import ticket from './ticket.js';
import time from './time.js';
import umbrella from './umbrella.js';
import understand_more from './understand-more.js';
import wallet from './wallet.js';
import welfare_credit from './welfare-credit.js';
import zoom from './zoom.js';
import parking from './parking.js';
import pets from './pets.js';
import accessibility from './accessibility.js';
import business_center from './business-center.js';
import children_services from './children-services.js';
import pool from './pool.js';
import restaurant from './restaurant.js';
import spa from './spa.js';
import like from './like.js';
import live_availability from './live-availability.js';
import prohibition from './prohibition.js';
import cot from './cot.js';
import shower from './shower.js';
import room_size from './room_size.js';
import door from './door.js';
import breakfast from './breakfast.js';
import dotted from './dotted.js';
import flag from './flag.js';
import minus_circle from './minus-circle.js';
import sun from './sun.js';
import beach from './beach.js';
import camping from './camping.js';
import lock_v2 from './lock-v2.js';
import check_circle from './check-circle.js';
import exclamation from './exclamation.js';
import gallery from './gallery.js';
import angle_left from './angle-left.js';
import angle_right from './angle-right.js';
import print from './print.js';
import remove from './remove.js';
import charging from './charging.js';
import leaf from './leaf.js';
import angle_small_up from './angle-small-up.js';
import angle_small_right from './angle-small-right.js';
import angle_small_down from './angle-small-down.js';
import angle_small_left from './angle-small-left.js';
import hamburger from './hamburger.js';
import store_android from './store-android.js';
import store_apple from './store-apple.js';
import whatsapp from './whatsapp.js';
import armchair from './armchair.js';
import login from './login.js';
import cross_circle from './cross-circle.js';
import compass from './compass.js';
import interrogation from './interrogation.js';
import palm from './palm.js';
import face_thinking from './face-thinking.js';
import map from './map.js';
import list from './list.js';
import c_card from './c-card.js';
import g_card from './g-card.js';
import pen from './pen.js';
import reverse from './reverse.js';
import region from './region.js';
import country from './country.js';
import ski from './ski.js';
import sport from './sport.js';
import golf from './golf.js';
import bike from './bike.js';
import surfing from './surfing.js';
import instruments from './instruments.js';
import stroller from './stroller.js';
import bed_left from './bed-left.js';
import lens from './lens.js';
import lens_blocked from './lens-blocked.js';
import close from './close.js';
// gift store: barra degli step, pill dell'hero e card dei vantaggi
import clipboard from './clipboard.js';
import party_popper from './party-popper.js';
import sparkle from './sparkle.js';
import bolt from './bolt.js';
import globe from './globe.js';
import cursor_click from './cursor-click.js';
// gift store: card "Scarica PDF" della pagina di conferma
import download from './download.js';
import envelope from './envelope.js';

export {
  // liveflight bags
  extra_bag,
  trolley,
  backpack,
  luggage,
  // liveflight chevrons
  chevron_up,
  chevron_right,
  chevron_left,
  chevron_down,
  checked,
  geo,
  tick,
  filters,
  mobile,
  carrier,
  large_bag,
  sun_half,
  traveler,
  priority,
  unlock,
  flight_ticket,
  plane,
  flight_start,
  flight_stop,
  // liveflight seat-map
  seat_choice,
  seat_blocked,
  // liveflight social
  facebook,
  instagram,
  linkedin,
  at_sign,
} from './liveflight';

import { infant, infant_info, child, user, occupants } from './user';

export {
  pen,
  infant,
  infant_info,
  child,
  baggage,
  air_arrival,
  air_start,
  airplane,
  alert,
  apple,
  arrow_l,
  arrow_r,
  bed,
  bus,
  calendar_edit,
  calendar,
  call_center,
  camera,
  cart,
  chat,
  check,
  city,
  clock,
  curly_quotes,
  hourglass,
  cutlery,
  district,
  doublebed,
  drink,
  email,
  engine,
  euro,
  exclamation,
  eye_close,
  eye_open,
  faq,
  filter,
  hands,
  happy_pin,
  have_voucher,
  heart,
  hotel,
  info,
  lamp_light,
  lamp,
  landmark,
  lock,
  logout,
  menu,
  moon,
  occupants,
  phone,
  pin,
  plus,
  plus_circle,
  plus_v2,
  quote,
  round_trip,
  shield,
  star,
  svg_error,
  tags,
  technology,
  ticket,
  time,
  umbrella,
  understand_more,
  user,
  wallet,
  welfare_credit,
  zoom,
  parking,
  pets,
  accessibility,
  business_center,
  children_services,
  pool,
  restaurant,
  spa,
  like,
  live_availability,
  prohibition,
  cot,
  shower,
  room_size,
  door,
  breakfast,
  dotted,
  flag,
  minus_circle,
  sun,
  beach,
  camping,
  lock_v2,
  check_circle,
  gallery,
  angle_left,
  angle_right,
  print,
  remove,
  charging,
  leaf,
  angle_small_up,
  angle_small_right,
  angle_small_down,
  angle_small_left,
  hamburger,
  store_android,
  store_apple,
  whatsapp,
  armchair,
  login,
  cross_circle,
  compass,
  interrogation,
  palm,
  face_thinking,
  map,
  list,
  c_card,
  g_card,
  reverse,
  region,
  country,
  ski,
  sport,
  golf,
  bike,
  surfing,
  instruments,
  stroller,
  bed_left,
  lens,
  lens_blocked,
  close,
  // gift store: barra degli step, pill dell'hero e card dei vantaggi
  clipboard,
  party_popper,
  sparkle,
  bolt,
  globe,
  cursor_click,
  // gift store: card "Scarica PDF" della pagina di conferma
  download,
  envelope,
};
